module.exports = __webpack_public_path__ + "img/btn-background.76b256c9.png";